import { render, staticRenderFns } from "./ManageOrganizationPage.vue?vue&type=template&id=7dba1ca6"
import script from "./ManageOrganizationPage.vue?vue&type=script&lang=ts"
export * from "./ManageOrganizationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports